var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComp2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 265,
    viewBox: "0 0 291 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 132.5,
    r: 132.5,
    fill: "#D1F1DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.696 70.1445H16.2266V210.577H73.696V70.1445Z",
    fill: "#7A7F99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8945 103.812V207.708",
    stroke: "white",
    strokeWidth: 0.99,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8945 79.3965V98.6194",
    stroke: "white",
    strokeWidth: 0.99,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8945 71.707V75.1005",
    stroke: "white",
    strokeWidth: 0.99,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.285 76.4355H33.0488V80.1232H41.285V76.4355Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4179 76.4355H46.1816V80.1232H54.4179V76.4355Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5507 76.4355H59.3145V80.1232H67.5507V76.4355Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.285 85.8906H33.0488V89.5783H41.285V85.8906Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4179 85.8906H46.1816V89.5783H54.4179V85.8906Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5507 85.8906H59.3145V89.5783H67.5507V85.8906Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.285 95.3438H33.0488V99.0314H41.285V95.3438Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4179 95.3438H46.1816V99.0314H54.4179V95.3438Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5507 95.3438H59.3145V99.0314H67.5507V95.3438Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4414 209.767H254.925C254.925 209.767 254.925 182.273 230.118 172.42C214.954 166.404 208.985 162.462 202.511 154.164C196.036 145.867 195.707 141.741 185.322 135.903C174.936 130.064 163.827 136.033 156.308 114.803C148.788 93.5729 115.836 90.6699 105.089 112.253C94.3421 133.837 91.4828 165.535 72.8806 168.981C54.2785 172.426 39.9292 174.211 37.4248 187.027C34.9204 199.842 19.1579 197.736 18.4414 209.767Z",
    fill: "#5E732F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M197.871 216.598H259.087L282.376 114.396C282.688 113.031 282.687 111.613 282.372 110.248C282.058 108.882 281.439 107.605 280.561 106.51C279.682 105.416 278.568 104.532 277.299 103.924C276.031 103.316 274.641 103.001 273.233 103H231.25C229.123 103.001 227.059 103.721 225.398 105.043C223.737 106.364 222.576 108.207 222.106 110.271L197.871 216.598Z",
    fill: "#19352A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M233.661 216.6H154.014",
    stroke: "#292E4A",
    strokeWidth: 1.02,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.242 216.598H43.0256L19.7368 114.396C19.425 113.031 19.4263 111.613 19.7406 110.248C20.0549 108.882 20.6741 107.605 21.5524 106.51C22.4306 105.416 23.5453 104.532 24.8138 103.924C26.0824 103.316 27.4721 103.001 28.8801 103H70.8631C72.9901 103.001 75.0535 103.721 76.7149 105.043C78.3763 106.364 79.5369 108.207 80.0064 110.271L104.242 216.598Z",
    fill: "#19352A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.694 216.6H35.0469",
    stroke: "#292E4A",
    strokeWidth: 1.02,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M190.602 82.9538H279.668C279.668 82.9538 266.325 80.4103 261.421 73.0088C258.601 68.7523 255.144 64.9535 251.022 64.9535C246.901 64.9535 240.624 66.137 238.468 62.1093C236.312 58.0816 230.422 51.4517 223.349 54.5313C216.276 57.6109 213.345 70.8773 207.455 72.5315C201.566 74.1858 194.526 74.4277 190.602 82.9538Z",
    fill: "#A6B1ED"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M56.791 57.9706H113.879C113.879 57.9706 110.159 54.7014 106.445 54.1653C102.731 53.6291 101.633 49.013 99.1158 47.8884C96.5983 46.7638 92.9896 46.4369 91.3529 43.828C89.7162 41.2192 82.3345 37.8977 76.1491 41.7619C71.4427 44.6976 69.4773 50.7914 66.6311 50.9157C63.7849 51.0399 57.4483 53.943 56.791 57.9706Z",
    fill: "#A6B1ED"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.182 194.141H158.129",
    stroke: "white",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.182 203.424H178.907",
    stroke: "white",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M143.182 212.709H178.907",
    stroke: "white",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M155.363 172.086L185.685 155.635H212.668L219.563 128.84H176.857L144.635 122.91L125.566 147.495L155.363 172.086Z",
    fill: "#CF8D58"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M265.286 128.299L233.445 171.446",
    stroke: "#007683",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M93.824 128.841H106.412L122.7 122.904H144.635L139.797 130.75L172.867 141.336C172.867 141.336 194.315 151.765 193.835 153.694C193.355 155.623 193.178 157.702 188.833 157.381C184.488 157.061 168.995 148.561 167.542 149.535C166.09 150.51 182.542 158.519 184.797 159.48C187.052 160.441 182.22 164.776 176.732 162.854C171.243 160.932 161.732 156.276 160.443 157.238C159.155 158.199 172.867 163.972 175.443 164.776C178.02 165.581 172.058 170.393 166.412 168.791C160.765 167.189 154.797 164.619 153.666 165.417C152.536 166.215 162.869 170.334 164.315 170.681C165.761 171.027 161.732 176.82 155.928 174.407C150.123 171.995 111.407 159.48 111.407 159.48H88.6641L93.824 128.841Z",
    fill: "#996740"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M115.154 159.99C115.154 159.99 124.691 150.836 126.545 149.221C128.399 147.606 135.176 151.948 131.804 155.289C128.432 158.63 122.857 163.2 122.857 163.2L124.77 163.854C124.77 163.854 120.826 166.659 116.383 165.129C111.939 163.599 113.668 161.409 115.154 159.99Z",
    fill: "#CF8D58"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.912 166.921C135.912 166.921 143.918 159.212 145.495 157.885C147.073 156.557 152.726 160.173 149.893 162.978C147.06 165.783 142.399 169.634 142.399 169.634L144.01 170.164C144.01 170.164 140.723 172.518 136.97 171.236C133.217 169.955 134.669 168.111 135.912 166.921Z",
    fill: "#CF8D58"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.509 170.301C144.509 170.301 150.629 164.416 152.075 163.174C153.521 161.932 158.812 165.305 156.17 167.914C154.377 169.65 152.492 171.289 150.523 172.825L152.015 173.315C152.015 173.315 148.933 175.505 145.442 174.315C141.952 173.125 143.352 171.412 144.509 170.301Z",
    fill: "#CF8D58"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M125.533 163.402C125.533 163.402 136.852 152.477 138.679 150.894C140.506 149.312 146.567 154.373 143.149 157.714C139.731 161.055 133.21 166.645 133.21 166.645L135.123 167.299C135.123 167.299 131.179 170.104 126.735 168.607C122.292 167.11 124.054 164.828 125.533 163.402Z",
    fill: "#CF8D58"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M176.856 128.84L151.739 120.412C150.146 119.88 148.45 119.721 146.784 119.948C145.118 120.175 143.527 120.781 142.136 121.72L125.512 132.966C125.29 133.116 125.115 133.325 125.005 133.568C124.895 133.812 124.856 134.081 124.892 134.346C124.927 134.611 125.036 134.86 125.206 135.067C125.376 135.274 125.6 135.429 125.854 135.516L127.642 136.131C128.811 136.532 130.071 136.586 131.271 136.288L145.732 132.678L176.856 128.84Z",
    fill: "#CF8D58"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4316 126.684H96.71L103.901 162.442L76.9772 167.032L61.4316 126.684Z",
    fill: "#007683"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3672 124.67H89.9593L98.3467 166.392L71.5084 170.962L37.3672 124.67Z",
    fill: "#8DDCA4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6679 171.614L36.0977 127.127",
    stroke: "#8DDCA4",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9395 175.806L98.3458 166.391",
    stroke: "#8DDCA4",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1065 140.361H67.5039",
    stroke: "#292E4A",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1553 137.661C77.1536 137.661 77.9629 136.856 77.9629 135.863C77.9629 134.869 77.1536 134.064 76.1553 134.064C75.157 134.064 74.3477 134.869 74.3477 135.863C74.3477 136.856 75.157 137.661 76.1553 137.661Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5303 137.661C84.5286 137.661 85.3379 136.856 85.3379 135.863C85.3379 134.869 84.5286 134.064 83.5303 134.064C82.532 134.064 81.7227 134.869 81.7227 135.863C81.7227 136.856 82.532 137.661 83.5303 137.661Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M240.413 126.684H205.134L197.943 162.442L224.861 167.032L240.413 126.684Z",
    fill: "#8DDCA4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M263.939 124.67H211.346L202.959 166.392L229.791 170.962L263.939 124.67Z",
    fill: "#007683"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M257.904 175.806L203.498 166.391",
    stroke: "#007683",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M207.961 140.361H235.135",
    stroke: "black",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M217.301 135.862C217.302 136.218 217.197 136.566 216.999 136.863C216.802 137.159 216.52 137.391 216.189 137.528C215.859 137.665 215.496 137.701 215.145 137.633C214.793 137.564 214.471 137.393 214.217 137.142C213.964 136.891 213.791 136.571 213.721 136.222C213.65 135.873 213.686 135.511 213.823 135.182C213.959 134.853 214.191 134.572 214.488 134.374C214.786 134.176 215.135 134.07 215.493 134.07C215.971 134.07 216.43 134.259 216.769 134.595C217.108 134.93 217.299 135.386 217.301 135.862Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M222.862 137.661C223.861 137.661 224.67 136.856 224.67 135.863C224.67 134.869 223.861 134.064 222.862 134.064C221.864 134.064 221.055 134.869 221.055 135.863C221.055 136.856 221.864 137.661 222.862 137.661Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M211.346 124.67H272.634",
    stroke: "white",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9578 124.67H31.0488",
    stroke: "white",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9844 174.674C46.1229 174.753 46.1888 174.72 46.202 174.615C46.0899 174.674 46.0108 174.701 45.9844 174.674Z",
    fill: "#495285"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp2);
export default __webpack_public_path__ + "static/media/comp2.2c54af671d19bf99289a41848cbcb001.svg";
export { ForwardRef as ReactComponent };